export default {
  primaryFont: 'Raleway, sans-serif',
  colors: {
    background: '#F7F7F7',
    primary: '#1488CC',
    secondary: '#2B32B2',
    primaryText: '#1B0000',
    accent: 'white',
    primaryGradient: 'linear-gradient(to right, #1488CC, #2B32B2)',
    headerGradient: 'linear-gradient(to left, #2B32B2, #1488CC)',
    lightAccent: 'white'
  },
  fontSize: {
    S: '0.7vw',
    default: '1vw',
    M: '1.2vw',
    L: '1.5vw',
    XL: '2vw',
    XXL: '3vw',
    XXXL: '5vw'
  },
};